export enum BillingFieldKeys {
  CORRESPONDENCE_ADDRESS = 'correspondenceAddress',
  SAME_CORRESPONDENCE_ADDRESS = 'sameCorrespondenceAddress',
  IBAN = 'iban',
  DELIVERY_MODE = 'deliveryMode',
  PAYMENT_METHOD = 'paymentMethod'
}

export enum CustomerFlows {
  SIMULATION = 'simulation',
  REGISTRATION = 'registration'
}

export enum InputGroupKeys {
  BILLING = 'billing',
  DELIVERY_ADDRESS = 'deliveryAddress',
  METER_DETAILS = 'meterDetails',
  OVERVIEW = 'overview',
  PERSONAL_DATA = 'personalData',
  SIMULATION = 'simulation'
}

export enum MeterDetailsFieldKeys {
  CONTRACT_START_DATE = 'contractStartDate',
  COUNTER_TYPE = 'counterType',
  DYNAMIC_TARIFF = 'dynamicTariff',
  EAN_CAPTURE_TYPE = 'eanCaptureType',
  ELECTRICITY = 'electricity',
  GAS = 'gas',
  HAS_SOLAR_PANELS = 'hasSolarPanels',
  KNOWS_METER_DETAILS = 'knowsMeterDetails',
  METER_READING_MONTH = 'meterReadingMonth',
  PREVIOUS_SUPPLIER = 'previousSupplier',
  SITUATION = 'situation',
  WALLONIA_SOLAR_PANELS_SINCE_2024 = 'walloniaSolarPanelsSince2024',
  UPLOAD = 'upload',
  PREVIOUS_INHABITANT = 'previousInhabitant',
  SETTLEMENT_FREQUENCY = 'settlementFrequency'
}

export enum OverviewFieldKeys {
  SIGNATURE = 'signature',
  CHOSEN_SIGN_CHANNEL = 'chosenSignChannel'
}

export enum DeliveryAddressFieldKeys {
  NEEDS_GAS = 'needsGas',
  ADDRESS = 'address'
}

export enum PersonalDataFieldKeys {
  COMPANY_NAME = 'companyName',
  COMPANY_NUMBER = 'companyNumber',
  CONTACT_MOMENT = 'contactMoment',
  CREDIT_CHECK = 'creditCheck',
  DATE_OF_BIRTH = 'dateOfBirth',
  EMAIL = 'email',
  FIRSTNAME = 'firstName',
  IS_COMPANY = 'isCompany',
  LANGUAGE = 'language',
  LASTNAME = 'lastName',
  LEGAL_FORM = 'legalForm',
  MOBILE_PHONE = 'mobilePhone',
  REPEAT_EMAIL = 'repeatEmail',
  SUBJECT_TO_VAT = 'subjectToVat'
}

export enum SimulationFieldKeys {
  FORCED_AMOUNT = 'forcedAmount',
  HAS_EXCLUSIVE_NIGHT_METER = 'hasExclusiveNightMeter',
  METER_TYPE = 'meterType',
  PRICE_WITHOUT_PROMO = 'priceWithoutPromo',
  PROMO_CODE = 'promoCode',
  REFERRAL_CODE = 'referralCode',
  REGION = 'region',
  SOLAR_PANELS = 'solarPanels',
  USAGE = 'usage',
  CHOSEN_SIMULATION_TYPE = 'chosenSimulationType'
}

export enum FlowAlternatives {
  TELESALES_CAMPAIGN = 'telesales-campaign',
  PLENTY = 'plenty',
  ITSME = 'itsme'
}
